import * as v from 'valibot'

import { Transaction } from '../trace.js'
import { GCPLog } from './misc.js'

export type ProfinderTransactionLog = GCPLog<Transaction>

const profinderStatuses = ['picked up', 'found', 'notfound'] as const

export const ProfinderQuerySchema = v.object({
  carrier: v.optional(v.string()),
  loadNum: v.optional(v.string()),
  externalId: v.optional(v.string()),
  result: v.optional(v.picklist([...profinderStatuses, 'all']), 'all'),
  from: v.optional(v.string()),
  to: v.optional(v.string()),
  trace: v.optional(v.string()),
  limit: v.optional(
    v.pipe(
      v.string(),
      v.transform(Number),
      v.integer(),
      v.minValue(1),
      v.maxValue(500),
    ),
    '50',
  ),
  sort: v.optional(v.string(), '-timestamp'),
  cursor: v.optional(v.string()),
})

export type ProfinderQuery = v.InferOutput<typeof ProfinderQuerySchema>

export type ProfinderLog = GCPLog<{
  valueFound?: string
  requestId: string
  proNum?: string
  source: string
  methodFound: string
  pickupDate: string
  refNums: Array<{ type: string; value: string }>
  bolNum: string
  scac: string
  pickupNum: string
  status: (typeof profinderStatuses)[number]
  message: string
  newPickupDate?: string
  code: string
  externalId: string
  reason?: string
  reasonDetail?: string
}>

export type LogsListResponse<T extends GCPLog = GCPLog> = {
  items: T[]
  nextCursor?: string
}
